export function LoadAEMPageData(src: any, dest: any): void {
  console.log('[DEBUG] Custom Handler for LoadAEMPageData src=', src, dest);
  dest.page.pageInfo.prevPageName = dest.page.pageInfo.pageName;
  dest.page.pageInfo.pageName = src.metadata.en['page-name'];
  dest.page.pageInfo.previousPageURL = dest.page.pageInfo.pageURL;
  dest.page.pageInfo.pageURL = window.location.href.split('?')[0];
  dest.page.pageInfo.pageURLFull = window.location.href;
  dest.page.pageInfo.domain = window.location.host;
  dest.page.pageInfo.timeStamp = new Date().toISOString();
  // TODO: Initialize App Event: page.category.channel = CHANNELS[SETTINGS.CHANNEL];
  // TODO: Initialize App Event: page.category.subChannel = CHANNEL_IDS[SETTINGS.CHANNEL];
  console.log('[DEBUG] Returning...Custom Handler for LoadAEMPageData src=', src, dest);
}
